import { FunctionComponent, memo, useMemo } from 'react';
import _ from 'lodash';
import { useGetEventUsers } from '~components/hooks';

import { Winner } from './Winner';
import { Event as EventType, Profile as ProfileType } from '~types';

interface Props {
  getEvent: EventType;
  getProfile: ProfileType;
}

export const Winners: FunctionComponent<Props> = memo(
  ({ getEvent, getProfile }) => {
    const getEventUsers = useGetEventUsers({
      eventId: getEvent.id,
      filters: { limit: 5 },
    });

    const getPrizes = useMemo(
      () => _.take(getEvent?.getPrizes, 5),
      [getEvent?.getPrizes],
    );

    return (
      <div className="breezy-winners">
        <div className="in-case-wrap">
          {_.map(getPrizes, (getPrize, index) => (
            <Winner
              key={getPrize.id}
              getWinner={_.get(getEventUsers?.getEventUsers, [index])}
              getPrize={getPrize}
              getProfile={getProfile}
              index={index + 1}
            />
          ))}
        </div>
      </div>
    );
  },
);
